var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_12428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6537 7.57579C11.6537 10.4892 9.61435 11.9459 7.19039 12.7908C7.06346 12.8338 6.92558 12.8318 6.79999 12.785C4.3702 11.9459 2.33081 10.4892 2.33081 7.57579V3.49701C2.33081 3.34247 2.3922 3.19427 2.50147 3.08499C2.61075 2.97572 2.75896 2.91433 2.91349 2.91433C4.07886 2.91433 5.53557 2.21511 6.54944 1.32943C6.67288 1.22396 6.82991 1.16602 6.99228 1.16602C7.15464 1.16602 7.31167 1.22396 7.43512 1.32943C8.45481 2.22093 9.90569 2.91433 11.0711 2.91433C11.2256 2.91433 11.3738 2.97572 11.4831 3.08499C11.5924 3.19427 11.6537 3.34247 11.6537 3.49701V7.57579Z",
    stroke: "#6A7282",
    strokeWidth: 1.16537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_12428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9844,
    height: 13.9844,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.b6ecefdb5e8caf40afbe44aae8c8e988.svg";
export { ForwardRef as ReactComponent };